module.exports = __webpack_public_path__ + "img/vertical_4_7_2.513741fb.png";